module.exports = {
      id: "brokenLaptop-usage",
      viewBox: "0 0 165 165",
      url: __webpack_public_path__ + "sprite.b16108e5f95a8323b5a812454e446fa5.svg#brokenLaptop-usage",
      toString: function () {
        return this.url;
      }
    }